import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './../styles/default.css';
import './../styles/default/home.css';
import * as globals from './../components/GlobalScripts.js';
import NavbarTop from './default/Navbartop';
import Footer from './default/Footer';
import Rating from './rating/Rating';

import banner1 from './../components/home/banner1.jpg';
import banner2 from './../components/home/banner2.jpg';
import ricardo_flores from './../components/home/ricardo_flores.png';
import susana_lopez from './../components/home/susana_lopez.png';
import icono_tecnologia from './../components/categorias_iconos/tecnologia.png';
import icono_mudanzas from './../components/categorias_iconos/mudanzas.png';
import icono_mecanica from './../components/categorias_iconos/mecanica.png';
import icono_persianas from './../components/categorias_iconos/persianas.png';
import icono_pintura from './../components/categorias_iconos/pintura.png';
import icono_limpieza from './../components/categorias_iconos/limpieza.png';
import icono_jardineria from './../components/categorias_iconos/jardineria.png';
import icono_herreria from './../components/categorias_iconos/herreria.png';
import icono_aire_acondicionado from './../components/categorias_iconos/aire-acondicionado.png';
import icono_albanil from './../components/categorias_iconos/albanil.png';
import icono_cerrajero from './../components/categorias_iconos/cerrajero.png';
import icono_cristalero from './../components/categorias_iconos/cristalero.png';
import icono_electricista from './../components/categorias_iconos/electricista.png';
import icono_electrodomesticos from './../components/categorias_iconos/electrodomesticos.png';
import icono_fontanero from './../components/categorias_iconos/fontanero.png';
import icono_carpinteria from './../components/categorias_iconos/carpinteria.png';
import icono_piscinas from './../components/categorias_iconos/piscinas.png';
import icono_tapiceria from './../components/categorias_iconos/tapiceria.png';
import icono_mantenimiento from './../components/categorias_iconos/mantenimiento-computadoras.png';


const Home = () => {
    let path_api = localStorage.getItem('path_api');
    const [user, setUser] = useState([]);
    const navigate = useNavigate();
    const [categoriasOptions, setCategoriasOptions] = useState([]);
    const [categoriasDescripciones, setCategoriasDescripciones] = useState([]);
    const [estadosCiudades, setEstadosCiudades] = useState([]);
    const [formDataSearch, setFormDataSearch] = useState({
        categoria: "Mudanzas",
        titulo: "",
        descripcion_servicio: "",
        estado: "Aguascalientes",
        ciudad: "Aguascalientes",
    });
    const [descripcionPlaceholder, setDescripcionPlaceholder] = useState("Ej. Me cambio de casa y necesito trasladar mis muebles y electrodomésticos de forma segura.");

    useEffect(() => {
        const cachedData = localStorage.getItem('formDataSearch');
        if (cachedData) {
            setFormDataSearch(JSON.parse(cachedData));
        }
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            setUser(JSON.parse(user_cache));
        }
        get_categorias();
        get_estados_ciudades();
    }, []);

    const get_categorias = () => {
        axios.post(`${path_api}/default/get_categorias.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setCategoriasOptions(response.data.categorias);
                setCategoriasDescripciones(response.data.descripciones);
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se cargaron las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al cargar las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    const get_estados_ciudades = () => {
        axios.post(`${path_api}/default/get_estados_ciudades.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                const estados = response.data.estados;
                setEstadosCiudades(estados);
                setFormDataSearch(prev => {
                    const newEstado = prev.estado || (estados.length > 0 ? estados[0].nombre : "");
                    const estadoObj = estados.find(e => e.nombre === newEstado);
                    const newCiudad = estadoObj && estadoObj.ciudades && estadoObj.ciudades.length > 0
                    ? estadoObj.ciudades[0].nombre
                    : "";
                    return {
                    ...prev,
                    estado: newEstado,
                    ciudad: newCiudad
                    };
                });
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se cargaron los estados y ciudades",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar estados y ciudades",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormDataSearch(prev => ({ ...prev, [name]: value }));
        if (name === "categoria") {
          const index = categoriasOptions.findIndex(cat => cat === value);
          if (index !== -1) {
            setDescripcionPlaceholder(categoriasDescripciones[index]);
          } else {
            setDescripcionPlaceholder("Ej.");
          }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        localStorage.setItem('formDataSearch', JSON.stringify(formDataSearch));
        navigate('/categorias/');
    };

    const handleCategoryClick = (category) => {
        formDataSearch.categoria = category;
        localStorage.setItem('formDataSearch', JSON.stringify(formDataSearch));
    };

    return (
        <div className="app-default app-container">
            <NavbarTop />
            <div className="main-content page-home">
                <div className="page-container">
                    <div className='container-section flex-column gap-20'>
                        <h2>¿Qué servicio necesitas?</h2>

                        <div className="container-services-home">
                            <Link to="/categorias/" title="Soluciones Integrales en Traslados y Logística" onClick={() => handleCategoryClick("Mudanzas")}>
                                <img src={icono_mudanzas} alt="Mudanzas" />
                                <p>Mudanzas</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Reparación y Mantenimiento" onClick={() => handleCategoryClick("Mecánica")}>
                                <img src={icono_mecanica} alt="Mecánica" />
                                <p>Mecánica</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Persianas" onClick={() => handleCategoryClick("Persianas")}>
                                <img src={icono_persianas} alt="Persianas" />
                                <p>Persianas</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Pintura" onClick={() => handleCategoryClick("Pintura")}>
                                <img src={icono_pintura} alt="Pintura" />
                                <p>Pintura</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Limpieza" onClick={() => handleCategoryClick("Limpieza")}>
                                <img src={icono_limpieza} alt="Limpieza" />
                                <p>Limpieza</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Jardinería" onClick={() => handleCategoryClick("Jardinería")}>
                                <img src={icono_jardineria} alt="Jardinería" />
                                <p>Jardinería</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Herrería" onClick={() => handleCategoryClick("Herrería")}>
                                <img src={icono_herreria} alt="Herrería" />
                                <p>Herrería</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Aire Acondicionado" onClick={() => handleCategoryClick("Aire Acondicionado")}>
                                <img src={icono_aire_acondicionado} alt="Aire Acondicionado" />
                                <p>Aire Acondicionado</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Albañilería" onClick={() => handleCategoryClick("Albañil")}>
                                <img src={icono_albanil} alt="Albañil" />
                                <p>Albañil</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Cerrajería" onClick={() => handleCategoryClick("Cerrajero")}>
                                <img src={icono_cerrajero} alt="Cerrajero" />
                                <p>Cerrajero</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Cristalería" onClick={() => handleCategoryClick("Cristalero")}>
                                <img src={icono_cristalero} alt="Cristalero" />
                                <p>Cristalero</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Electricidad" onClick={() => handleCategoryClick("Electricista")}>
                                <img src={icono_electricista} alt="Electricista" />
                                <p>Electricista</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Electrodomésticos" onClick={() => handleCategoryClick("Electrodomésticos")}>
                                <img src={icono_electrodomesticos} alt="Electrodomésticos" />
                                <p>Electrodomésticos</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Fontanería" onClick={() => handleCategoryClick("Fontanero")}>
                                <img src={icono_fontanero} alt="Fontanero" />
                                <p>Fontanero</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Carpintería" onClick={() => handleCategoryClick("Carpintería")}>
                                <img src={icono_carpinteria} alt="Carpintería" />
                                <p>Carpintería</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Piscinas" onClick={() => handleCategoryClick("Piscinas")}>
                                <img src={icono_piscinas} alt="Piscinas" />
                                <p>Piscinas</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Integrales en Tapicería" onClick={() => handleCategoryClick("Tapicería")}>
                                <img src={icono_tapiceria} alt="Tapicería" />
                                <p>Tapicería</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Tecnológicas Integrales" onClick={() => handleCategoryClick("Servicios Software / Programacion")}>
                                <img src={icono_tecnologia} alt="Servicios Software / Programación" />
                                <p>Servicios Software / Programación</p>
                            </Link>

                            <Link to="/categorias/" title="Soluciones Tecnológicas Integrales" onClick={() => handleCategoryClick("Mantenimiento Computadoras")}>
                                <img src={icono_mantenimiento} alt="Mantenimiento Computadoras" />
                                <p>Mantenimiento Computadoras</p>
                            </Link>
                        </div>

                    </div>

                    <div className='container-section margin-top-50 container-search-section'>
                        <div className="container-search-home">
                            {user?.nombre && (
                                <div className="flex-column gap-10">
                                    <h5>Bienvenido {user.nombre},</h5>
                                    <h2>Encuentra al experto que necesitas</h2>
                                </div>
                            )}
                            {!user?.nombre && (
                                <h2>Encuentra al experto que necesitas</h2>
                            )}
                            <p>¡Chatea con 3 o más profesionales al momento y consigue tu presupuesto ideal! No compartimos tu dirección ni teléfono con nadie.</p>

                            <form onSubmit={handleSubmit} className="flex-column gap-20">
                                <div className="form-group">
                                    <label htmlFor="categoria">Categoría</label>
                                    <select
                                        id="categoria"
                                        name="categoria"
                                        value={formDataSearch.categoria}
                                        onChange={handleChange}
                                        className="input-primary"
                                        required
                                    >
                                        {categoriasOptions.map((categoria, index) => (
                                            <option key={index} value={categoria}>
                                                {categoria}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="descripcion_servicio">Descripción de servicio</label>
                                    <textarea
                                        type="text"
                                        id="descripcion_servicio"
                                        name="descripcion_servicio"
                                        value={formDataSearch.descripcion_servicio}
                                        onChange={handleChange}
                                        className="input-primary"
                                        placeholder={descripcionPlaceholder}
                                        rows="3"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Indique estado y ciudad donde se requiere el servicio</label>
                                    <select
                                        id="estado"
                                        name="estado"
                                        value={formDataSearch.estado}
                                        onChange={handleChange}
                                        className="input-primary"
                                        required
                                    >
                                        {estadosCiudades.map((item, index) => (
                                            <option key={index} value={item.nombre}>
                                                {item.nombre}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        id="ciudad"
                                        name="ciudad"
                                        value={formDataSearch.ciudad}
                                        onChange={handleChange}
                                        className="input-primary"
                                        required
                                    >
                                        {(() => {
                                            const selectedState = estadosCiudades.find(
                                                (item) => item.nombre === formDataSearch.estado
                                            );
                                            return selectedState && selectedState.ciudades
                                                ? selectedState.ciudades.map((ciudad) => (
                                                    <option key={ciudad.id} value={ciudad.nombre}>
                                                        {ciudad.nombre}
                                                    </option>
                                                ))
                                                : null;
                                        })()}
                                    </select>
                                </div>

                                <div className="flex-row justify-end gap-20">
                                    <button className="button-primary" type="submit">Buscar</button>
                                </div>
                            </form>
                        </div>
                        <div className="container-img-search-home" style={{ backgroundImage: `url(${banner1})` }}>
                            <div className='overlay-container'></div>
                            <h1>Profesionales<br />de confianza</h1>
                            <h4>Tenemos el talento<br />y la experiencia que buscas</h4>
                        </div>
                    </div>

                    <div className="banner-home-join" style={{ backgroundImage: `url(${banner2})` }}>
                        <div className='container-section flex-column gap-20'>
                            <h1>Únete a Don<br />Honesto</h1>
                            <h4>La confianza de trabajar honestamente</h4>
                            <Link to="/quiero-trabajar" className="button-primary">Únete ahora</Link>
                        </div>
                    </div>

                    <div className='container-section flex-column margin-top-50 gap-20 center'>
                        <h2>Testimonios</h2>
                        <h5>Un cliente satisfecho es la mejor recomendación</h5>

                        <div className="container-reviews">
                            <div className="review">
                                <img src={ricardo_flores}></img>
                                <h4>Ricardo Flores</h4>
                                <h5>Supervisor</h5>
                                <Rating rating={5} size={20} />
                                <p>
                                    Contraté los servicios de plomería a través de Don Honesto y quedé completamente satisfecho.<br /><br />

                                    El profesional llegó a tiempo, solucionó el problema de manera rápida y eficiente, y fue muy amable en todo momento.<br /><br />

                                    ¡Definitivamente lo recomiendo!
                                </p>
                            </div>
                            <div className="review">
                                <img src={susana_lopez}></img>
                                <h4>Susana López</h4>
                                <h5>Dueña de negocio</h5>
                                <Rating rating={5} size={20} />
                                <p>
                                    Don Honesto es una excelente plataforma para encontrar expertos en reparaciones.<br /><br />

                                    Necesitaba un carpintero para un proyecto urgente y, a través del sitio, conseguí un profesional calificado en menos de 24 horas.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Home;
